export const environment = {
  production: true,
  baseUrl: 'https://api.aggendai.com.br',
  apiUrl: 'https://api.aggendai.com.br/api',
  googleClientId: '703270295951-nfnducmjj7tejqcv8n2iugvptcc3hq5o.apps.googleusercontent.com',
};
